import Carrier from './Carrier';

export default Carrier;
